import { render, staticRenderFns } from "./MiddleUI.vue?vue&type=template&id=1a8b7bd4"
import script from "./MiddleUI.vue?vue&type=script&lang=js"
export * from "./MiddleUI.vue?vue&type=script&lang=js"
import style0 from "./MiddleUI.vue?vue&type=style&index=0&id=1a8b7bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports